// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../github.com:rancher/dashboard/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../github.com:rancher/dashboard/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inline-banner-container[data-v-efcb594c]{position:relative}.inline-error-banner[data-v-efcb594c]{position:absolute;width:100%}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
